<div class="title-and-description">
	<div class="subsection-smallcaps-title">Import JSON</div>
	<div class="section-description">
		Provide a JSON object to create and update the flags and values of this scope snapshot.
	</div>
</div>
<form [formGroup]="importForm">
	<app-monaco-editor
		formControlName="json"
		class="json-input"
		pAutoFocus
		[autofocus]="true">
	</app-monaco-editor>
	<div class="action-link advanced-options" (click)="showingAdvancedOptions = !showingAdvancedOptions">
		<div class="action-link-label">{{ !showingAdvancedOptions ? 'Show' : 'Hide' }} advanced import options</div>
		<div class="ficon" [class]="{
			'ficon-ChevronDownMed': !showingAdvancedOptions,
			'ficon-ChevronUpMed': showingAdvancedOptions
		}"></div>
	</div>
	<div class="import-option-groups" *ngIf="showingAdvancedOptions">
		<div class="import-option-group flag-node-import-options">
			<div class="subsection-smallcaps-title">Flag Node Handling</div>
			<div *ngFor="let optionKey of flagNodeImportOptions" class="field-checkbox">
				<p-radioButton [inputId]="'flagNodeImportOption-' + optionKey" [value]="optionKey" formControlName="flagNodeImportOption"></p-radioButton>
				<label [for]="'flagNodeImportOption-' + optionKey" class="ml-2" [innerHTML]="flagNodeImportOptionLabel(optionKey)"></label>
			</div>
		</div>
		<div class="import-option-group flag-value-import-options" *ngIf="showingAdvancedOptions">
			<div class="subsection-smallcaps-title">Flag Value Handling</div>
			<div *ngFor="let optionKey of flagValueImportOptions" class="field-checkbox">
				<p-radioButton [inputId]="'flagValueImportOption-' + optionKey" [value]="optionKey" formControlName="flagValueImportOption"></p-radioButton>
				<label [for]="'flagValueImportOption-' + optionKey" class="ml-2" [innerHTML]="flagValueImportOptionLabel(optionKey)"></label>
			</div>
		</div>
		<div class="import-option-group array-import-options" *ngIf="showingAdvancedOptions">
			<div class="subsection-smallcaps-title">Array Handling</div>
			<div *ngFor="let optionKey of arrayImportOptions" class="field-checkbox">
				<p-radioButton [inputId]="'arrayImportOption-' + optionKey" [value]="optionKey" formControlName="arrayImportOption"></p-radioButton>
				<label [for]="'arrayImportOption-' + optionKey" class="ml-2" [innerHTML]="arrayImportOptionLabel(optionKey)"></label>
			</div>
		</div>
	</div>

	<ng-container *ngIf="jsonInputIncompatibilities?.length">
		<div class="incompatible-flags-and-values-section">
	
			<div class="icon-and-title-for-incompatibilities-section" *ngIf="incompatibilitiesSectionTitle() as sectionTitle">
				<div class="ficon ficon-ReportWarning"></div><div class="subsection-smallcaps-title">{{ sectionTitle }}</div>
			</div>
			<div class="incompatible-flags-and-values">
				<div class="grid-header">Path to Be Skipped</div>
				<div class="grid-header">Existing Type</div>
				<div class="grid-header">Provided Type / Data</div>
	
				<ng-container *ngFor="let incompatibility of jsonInputIncompatibilities">
					<div class="flag-path code">
						{{ incompatibilityPath(incompatibility.path) }}
					</div>
	
					<div class="expected-type">
						{{ incompatibility.expectedType | titlecase }}
					</div>
					
					<div class="provided-type">
						<span>{{ incompatibility.providedType | titlecase }}:</span>
					
						<span class="provided-value code">
							{{ incompatibilityValue(incompatibility.providedValue) }}
						</span>
					</div>
				</ng-container>
			</div>
		</div>
	</ng-container>
</form>

<div class="actions">
	<div pRipple class="button import" *ngIf="importForm.valid" (click)="importJson()"><div class="ficon ficon-Installation"></div> Import into {{versionLabel(this.requireScopeSnapshot().scopeVersion)}}</div>
	<div class="error-notice-and-icon" *ngIf="!importForm.valid"><div class="ficon ficon-Important"></div><div class="error-notice">Fix your JSON in order to proceed.</div></div>
	<div class="action-link" (click)="cancelImport()">
		<div class="ficon icon ficon-Cancel"></div>Cancel
	</div>
</div>